import React from 'react'
import Header from "../componets/Header"
import Footer from "../componets/Footer"
import Error from '../componets/pagenotfound/Error'

const PageNotFound = () => {
    return (
        <>
            <Header />
            <Error />
            <Footer />
        </>
    )
}

export default PageNotFound